export const getAvailableLanguages = ({
  languageLinkedContent,
  legacyLanguages,
  currentLanguage
}) => {
  if (languageLinkedContent !== null && languageLinkedContent !== void 0 && languageLinkedContent.languageToPagePath) {
    const linkedLanguages = Object.keys(languageLinkedContent.languageToPagePath);
    return [...new Set([currentLanguage, ...linkedLanguages])];
  }
  return legacyLanguages;
};